<template>
    <div class="hero-container">
        <div class="image" />
        <div class="text-container">
            <h1>{{ $t('hero.title') }}</h1>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Hero'
    }
</script>

<style scoped>
.hero-container {
    width: 100%;
    position: relative;
    margin-top: 56px;
}

.text-container {
    position: absolute;
    top: 0;
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

h1 {
    text-align: center;
    color: #fff;
    font-size: 2.3rem;
    font-family: Roboto, sans-serif;
    font-weight: 350;
}

.image {
    background-image: url('~@/assets/images/hero.jpg');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    width: 100%;
    min-height: 140px;
}

@media screen and (min-width: 480px) {
    .hero-container {
        margin-top: 76px;
    }

    .image {
        min-height: 275px;
    }
}

@media screen and (min-width: 768px) {
    .hero-container {
        margin-top: 98px;
    }

    .image {
        min-height: 340px;
    }
}

@media screen and (min-width: 992px) {
    .hero-container {
        margin-top: 106px;
    }

    .image {
        min-height: 400px;
    }
}

@media screen and (min-width: 1200px) {
    .hero-container {
        margin: 106px auto 0;
        max-width: 1920px;
    }

    .image {
        margin-top: 100px;
        min-height: 715px;
    }

    h1 {
        font-size: 3.5rem;
    }
}

</style>